"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMedications = void 0;
var _lodash = require("lodash");
var _react = _interopRequireWildcard(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _core = require("@monument/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var medicationDescriptions = {
  naltrexone: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("strong", null, "Naltrexone"), " is used in alcohol treatment for those looking to achieve abstinence or reduce their drinking. Naltrexone helps combat alcohol cravings while also blocking the rewarding aspects of drinking. This relationship between naltrexone and alcohol occurs because when naltrexone is present in the brain, alcohol cannot stimulate the release of dopamine."),
  disulfiram: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("strong", null, "Disulfiram"), " increases sensitivity to drinking alcohol and causes many effects of a hangover to be felt immediately following alcohol consumption by inhibiting the enzyme acetaldehyde dehydrogenase. If you are looking to achieve alcohol abstinence, disulfiram may be an effective treatment option for you.")
};
var useMedications = function useMedications(medications) {
  var isMedicationsPrescribed = !(0, _lodash.isEmpty)(medications) && medications.some(function (m) {
    return (0, _core.isValidPrescription)(m);
  });
  var validMedications = medications === null || medications === void 0 ? void 0 : medications.filter(_core.isValidPrescription);
  var validUnexpiredMedications = (0, _lodash.reject)(validMedications, function (medication) {
    // This logic to determine when to alert the member of a renewal was copied from
    // pharmacy.service.ts#handleSendReminderForMedicationRunOut on the backend.
    var refills = Number(medication.refills) || 0;
    var daysSupply = medication.daysSupply || parseInt(medication.quantity, 10) || 30;
    var effectiveDate = (0, _momentTimezone.default)(medication.effectiveDate);
    var daysSinceEffectiveDate = (0, _momentTimezone.default)().diff(effectiveDate, 'days');
    var totalFills = refills + 1;
    var dayNumberToAlertForRenewal = Math.max(daysSupply * totalFills - 10, 1);
    return daysSinceEffectiveDate >= dayNumberToAlertForRenewal;
  });
  var medDescriptions = (0, _react.useMemo)(function () {
    if (!isMedicationsPrescribed || !(validMedications !== null && validMedications !== void 0 && validMedications.length)) {
      return [];
    }
    var prescriptionsList = validMedications.map(function (medication) {
      return (0, _lodash.lowerCase)(medication.genericDrugName);
    });
    return (0, _lodash.chain)(medicationDescriptions).map(function (value, name) {
      return prescriptionsList.includes(name) && {
        name: name,
        value: value
      };
    }).compact().value();
  }, [isMedicationsPrescribed, validMedications]);
  var everHadAnyPrescriptions = validMedications.length > 0;
  return {
    isMedicationsPrescribed: isMedicationsPrescribed,
    validUnexpiredMedications: validUnexpiredMedications,
    medDescriptions: medDescriptions,
    everHadAnyPrescriptions: everHadAnyPrescriptions
  };
};
exports.useMedications = useMedications;